import { SidebarItemType } from "../types/Sidebar.types";

export const SidebarData: SidebarItemType[] = [
  { id: "home", label: "Home", path: "/dashboard" },


  // Master
  {
    id: "master",
    label: "Master",
    path: "/master",
    children: [
      // {
      //   id: "master sub1",
      //   label: "master sub1",
      //   path: "/master/sub1",
      //   children: [
      //     {
      //       id: "team",
      //       label: "Team",
      //       path: "/users/team",
      //       children: [
      //         {
      //           id: "members",
      //           label: "Members",
      //           path: "/users/team/members",
      //           children: [
      //             { id: "member-details", label: "Member Details", path: "/users/team/members/details" },
      //           ],
      //         },
      //         { id: "roles", label: "Roles", path: "/users/team/roles" },
      //       ],
      //     },
      //     { id: "user-settings", label: "User Settings", path: "/users/settings" },
      //   ],
      // },
      {
        id: "master users",
        label: "Users",
        path: "/master/users",
      },
        {
        id: "master hq",
        label: "HQ",
        path: "/master/hq",
      },
        {
        id: "master regions",
        label: "Regions",
        path: "/master/regions",
      },
        {
        id: "master designations",
        label: "Designations",
        path: "/master/designations",
      },
        {
        id: "master subjects",
        label: "Subjects",
        path: "/master/subjects",
      },
        {
        id: "master calender",
        label: "Calender",
        path: "/master/calender",
      },
        {
        id: "master stationstate",
        label: "Station & State",
        path: "/master/stationstate",
      },
    ],
  },

  // KVIS
  {
    id: "kvis",
    label: "KVIS",
    path: "/kvis",
    children: [
      { id: "kvis-school", 
        label: "School", 
        path: "/kvis/school" },
      { id: "kvis-kv", 
        label: "KV", 
        path: "/kvis/kv" },
      { id: "kvis-report", 
      label: "Report", 
      path: "/kvis/report",
      children: [
        { id: "kvis-report-updateReport", 
        label: "Update Report", 
        path: "/kvis/report/updateReport" },
        { id: "kvis-report-CCTVReport", 
        label: "CCTV Report", 
        path: "/kvis/report/updateReport"},
        { id: "kvis-report-CWSNInfraReport", 
        label: "CWSN Infra Report", 
        path: "/kvis/report/updateReport" },
        { id: "kvis-report-CWSNReport", 
        label: "CWSN Report", 
        path: "/kvis/report/updateReport" },
        { id: "kvis-report-libraryReport", 
        label: "Library Report", 
        path: "/kvis/report/updateReport" },
        { id: "kvis-report-ConsolidatedICT", 
        label: "Consolidated ICT", 
        path: "/kvis/report/updateReport" },
        { id: "kvis-report-Infrastructure", 
        label: "Infrastructure", 
        path: "/kvis/report/updateReport" },
        { id: "kvis-report-SportInfrastructure", 
        label: "Sport Infrastructure", 
        path: "/kvis/report/updateReport" },
        { id: "kvis-report-NCCReport", 
        label: "NCC Report", 
        path: "/kvis/report/updateReport" },
      ]
      },
      { id: "kvis-custom-report", 
      label: "Custom Report", 
      path: "/kvis/customreport" },
    ],
  },

  // PIS
  {
    id: "pis",
    label: "PIS",
    path: "/pis",
    children: [
      { id: "pis-sub1", label: "PIS sub1", path: "/pis/sub1" },
      { id: "pis-sub2", label: "PIS sub2", path: "/pis/sub2" },
    ],
  },

  // SIS
  {
    id: "sis",
    label: "SIS",
    path: "/pis",
    children: [
      { id: "pis-sub1", label: "PIS sub1", path: "/pis/sub1" },
      { id: "pis-sub2", label: "PIS sub2", path: "/pis/sub2" },
    ],
  },

  // PM Shri
  {
    id: "pmshri",
    label: "PM Shri",
    path: "/pis",
    children: [
      { id: "pis-sub1", label: "PIS sub1", path: "/pis/sub1" },
      { id: "pis-sub2", label: "PIS sub2", path: "/pis/sub2" },
    ],
  },

  // Staff Sanction
  {
    id: "staff",
    label: "Staff Sanction",
    //path: "/staffSanction",
    path: "/staffSanction/staffSanctionDashboard",
    children: [
      { id: "staffSanction-staffSanctionDashboard",
        label: "Staff Sanction Dashboard", 
        path: "/staffSanction/staffSanctionDashboard" 
      },
      { id: "staffSanction-sanctionSanction",
        label: "Sanction of Sanction", 
        //path: "/staffSanction/sanctionSanction",
        path: "/staffSanction/sanctionSanction/status",
        children: [
          { id: "staffSanction-sanctionSanction-status",
            label: "Status", 
            path: "/staffSanction/sanctionSanction/status" 
          },
          { id: "staffSanction-sanctionSanction-document",
            label: "Document", 
            path: "/staffSanction/sanctionSanction/document" 
          },
          { id: "staffSanction-sanctionSanction-generatePDF",
            label: "Generate PDF", 
            path: "/staffSanction/sanctionSanction/generatePDF" 
          },
          { id: "staffSanction-sanctionSanction-withChanges",
            label: "With Changes", 
            path: "/staffSanction/sanctionSanction/withChanges" 
          },
          { id: "staffSanction-sanctionSanction-withNoChanges",
            label: "With No Changes", 
            path: "/staffSanction/sanctionSanction/withNoChanges" 
          },
          { id: "staffSanction-sanctionSanction-approvedSanction",
            label: "Approved Sanction", 
            path: "/staffSanction/sanctionSanction/approvedSanction" 
          },
        ],
      },
      { id: "staffSanction-report",
        label: "Report", 
        path: "/staffSanction/report",
        children: [
          { id: "staffSanction-report-enrollmentSection",
            label: "Enrollment & Section", 
            path: "/staffSanction/report/enrollmentSection" 
          },
          { id: "staffSanction-report-staffSanctionRubrics",
            label: "Staff Sanction Rubrics", 
            path: "/staffSanction/report/staffSanctionRubrics" 
          },
          { id: "staffSanction-report-periodDistributionRubrics",
            label: "Period Distribution Rubrics", 
            path: "/staffSanction/report/periodDistributionRubrics" 
          },
          { id: "staffSanction-report-kvWiseWorkload",
            label: "KV Wise Workload", 
            path: "/staffSanction/report/kvWiseWorkload" 
          },
          { id: "staffSanction-report-kvSanctionedPost",
            label: "KV Sanctioned Post", 
            path: "/staffSanction/report/kvSanctionedPost" 
          },
        ],
      },
      { id: "staffSanction-mergedClassDetails",
        label: "Merged Class Details", 
        path: "/staffSanction/mergedClassDetails" 
      },
      { id: "staffSanction-mergedClassEnrollment",
        label: "Merged Class & Enrollment", 
        path: "/staffSanction/mergedClassEnrollment" 
      },
    ],
  },

  // Balvatika
  {
    id: "balvatika",
    label: "Balvatika",
    path: "/balvatika",
    children: [
      // Application
      { id: "balvatika-application",
            label: "Application", 
            path: "/balvatika/application/overview",
            children: [
              { id: "balvatika-application-overview",
                label: "overview", 
                path: "/balvatika/application/overview" 
              },
              { id: "balvatika-application-applicationList",
                    label: "Application List", 
                    path: "/balvatika/application/applicationList" 
              },
              { id: "balvatika-application-roWiseStatistics",
                    label: "ROWiseStatistics", 
                    path: "/balvatika/application/roWiseStatistics" 
              },
            ]
      },

      // Miscellaneous
      { id: "balvatika-miscellaneous-config",
            label: "Miscellaneous", 
            path: "/balvatika/miscellaneous/config",
            children: [
              { id: "balvatika-miscellaneous-config",
                label: "overview", 
                path: "/balvatika/miscellaneous/config" 
              },
              { id: "balvatika-miscellaneous-seatsOverview",
                    label: "Seats Overview", 
                    path: "/balvatika/miscellaneous/seatsOverview" 
              },
              { id: "balvatika-miscellaneous-lotteryTimeslot",
                    label: "Lottery Timeslot", 
                    path: "/balvatika/miscellaneous/lotteryTimeslot" 
              },
            ]
      },

      // Admission
      { id: "balvatika-admission-admissionSummary",
            label: "Admission Summary", 
            path: "/balvatika/admission/admissionSummary",
            children : [
               { 
                  id: "balvatika-admission-admissionSummary",
                  label: "Admission Summary", 
                  path: "/balvatika/admission/admissionSummary" 
                },
                { id: "balvatika-admission-admittedCandidates",
                      label: "Admitted Candidates", 
                      path: "/balvatika/admission/admittedCandidates" 
                },
            ]
      },
      
    ],
  },

  // Analytics Copilot
  {
    id: "analytics",
    label: "Samiksha Samadhan",
    path: "/analytics/copilot",
    children: [
      { id: "analytics-copilot", label: "Copilot", path: "/analytics/copilot" },
      { id: "analytics-school-report", label: "School Report", path: "/analytics/school-report" },
      { id: "analytics-doc-chat", label: "Document Chat", path: "/doc-chat" },
    ],
  },

  // Sports
  {
    id: "sportrs",
    label: "Sports",
    path: "/sports",
    children: [
      { id: "sports-cgaevents", label: "CGA & Events", path: "/sports/cgaevents" },
    ],
  },
];